import { Injectable, signal } from '@angular/core';

/** When true, the demo HTTP interceptor short-circuits all API calls with dummy JSON. */
@Injectable({ providedIn: 'root' })
export class ModalDemoModeService {
	private readonly enabled = signal(false);

	public isEnabled(): boolean {
		return this.enabled();
	}

	public enable(): void {
		this.enabled.set(true);
	}

	public disable(): void {
		this.enabled.set(false);
	}
}
